// ⛔ umi 的 locale 插件只认 `src/locales/<lang>.ts` 这种**单文件**形式，
//    不会扫描 `src/locales/zh-CN/*.ts` 子目录（我踩过：构建不报错，但词典根本没进包）。
//    所以分模块的词典放在 src/dict/，在这里汇总导出。
import menu from '@/dict/zh-menu';
import common from '@/dict/zh-common';
import page from '@/dict/zh-page';
import page2 from '@/dict/zh-page2';
import page3 from '@/dict/zh-page3';
import page4 from '@/dict/zh-page4';

export default {
  ...menu,
  ...common,
  ...page,
  ...page2,
  ...page3,
  ...page4,
};
